import axios from "axios";

const BASE_PREFIX = "/dev-api";
import moment from "moment";

const instance = axios.create({
  timeout: 10000,
});

class BoHttp {
  request(method, url, param, axiosConfig) {
    url = BASE_PREFIX + url;

    const config = {
      method,
      url,
      ...param,
      ...axiosConfig,
    };

    return new Promise((resolve, reject) => {
      instance
        .request(config)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

/**
 * 字典children转化
 * 转化示例
 * transDictData(originalData, "home2Content")
 */
export function transDictData(data, type) {
  const grouped = {};

  data.forEach((item) => {
    const match = item.dictKey.match(
      new RegExp(type + "(\\d+)(Title|Content|SubTitle|Image)")
    );

    if (match) {
      const [, num, type] = match;
      if (!grouped[num]) grouped[num] = {};
      grouped[num][type.toLowerCase()] = item.dictValue;
    }
  });

  return Object.values(grouped).map((item) => ({
    title: item.title || "",
    content: item.content || "",
    subTitle: item.subTitle || "",
    image: item.image || "",
  }));
}

/**
 * 字典children转化（末尾没有类型）
 * 转化示例
 * transDictData(originalData, "home4Title1Content1")
 */
export function transDictDataNotType(data, type) {
  const grouped = {};

  data.forEach((item) => {
    const match = item.dictKey.match(new RegExp(type + "(\\d+)"));

    if (match) {
      const [, num] = match;
      if (!grouped[num]) grouped[num] = {};
      grouped[num] = item.dictValue;
    }
  });

  return Object.values(grouped);
}

/**
 * 字典children转化（末尾没有类型）多个种类
 * 转化示例
 * transDictData(originalData, "home4Title1Content1Tile")
 */
export function transDictDataNotTypeMore(data, type) {
  const grouped = {};

  data.forEach((item) => {
    const match = item.dictKey.match(
      new RegExp(type + "(\\d+)(Title|Content|SubTitle|Image)")
    );

    if (match) {
      const [, num, type] = match;
      if (!grouped[num]) grouped[num] = {};
      grouped[num][type.toLowerCase()] = item.dictValue;
    }
  });

  return Object.values(grouped).map((item) => ({
    title: item.title || "",
    content: item.content || "",
    subTitle: item.subtitle || "",
    image: item.image || "",
  }));
}

export function transDictDataNotTypeMore2(data, type) {
  const grouped = {};

  data.forEach((item) => {
    const match = item.dictKey.match(
      new RegExp(type + "(Title|Content|SubTitle|Image)(\\d+)")
    );

    if (match) {
      const [, type, num] = match;
      if (!grouped[num]) grouped[num] = {};
      grouped[num][type.toLowerCase()] = item.dictValue;
    }
  });

  return Object.values(grouped).map((item) => ({
    title: item.title || "",
    content: item.content || "",
    subTitle: item.subtitle || "",
    image: item.image || "",
  }));
}

export function transDictDataTotal(data, type) {
  let total = 0;
  data.forEach((item) => {
    const match = item.dictKey.match(new RegExp(type + "(\\d+).*"));

    if (match) {
      const [, num] = match;
      total = Math.max(total, num);
    }
  });

  const res = Array.from({ length: total }, () => ({}));

  for (let i = 1; i <= total; i++) {
    data.forEach((item) => {
      const match = item.dictKey.match(
        // 如果出现Title1这种情况（即Title和数字连在一起），则不进行匹配
        new RegExp(type + i + "(Title|Content|SubTitle|Image|Icon)(?!\\d)")
      );

      if (match) {
        const [, type] = match;
        res[i - 1][type] = item.dictValue;
      }
    });
  }

  for (let i = 1; i <= total; i++) {
    data.forEach((item) => {
      const match = item.dictKey.match(
        new RegExp(type + i + "(Title|Content|SubTitle|Image|Icon)(\\d+)")
      );

      if (match) {
        const [, type, num] = match;

        if (!res[i - 1][type]) res[i - 1][type] = [];
        res[i - 1][type].push(item.dictValue);
      }
    });
  }
  return res;
}

/**
 * 字典主类转化
 * 转化示例
 * transDictData(originalData, "home2")
 * 单个
 */
export function findMainProp(data, type) {
  const grouped = {};

  data.forEach((item) => {
    const match = item.dictKey.match(
      new RegExp(type + "(Title|Content|SubTitle|Image|Desc|Type)")
    );

    if (match) {
      const [, type] = match;
      grouped[type.toLowerCase()] = item.dictValue;
    }
  });

  return grouped;
}

/**
 * 字典主类转化
 * 转化示例
 * transDictData(originalData, "home4")
 * 多个
 */
export function findMainPropArr(data, type) {
  const grouped = {};

  data.forEach((item) => {
    const match = item.dictKey.match(
      new RegExp(type + "(Title|Content|SubTitle|Image|Desc|Type)(\\d+)")
    );

    if (match) {
      const [, type, num] = match;
      if (!grouped[num]) grouped[num] = {};
      grouped[num][type.toLowerCase()] = item.dictValue;
    }
  });

  return Object.values(grouped);
}

export function formatDateToYMD(dateStr) {
  return moment(dateStr).format("YYYY-MM-DD");
}

export function formatRelativeOrYMD(dateStr) {
  const now = moment();
  const date = moment(dateStr);
  const diffInHours = Math.abs(now.diff(date, "hours"));
  if (diffInHours < 24) {
    // 使用中文相对时间
    return date.locale('zh-cn').fromNow();
  } else {
    return date.format("YYYY-MM-DD");
  }
}

export const http = new BoHttp();
